import p from "./index895.js";
var t = typeof exports == "object" && exports && !exports.nodeType && exports, e = t && typeof module == "object" && module && !module.nodeType && module, u = e && e.exports === t, r = u && p.process, l = (function() {
  try {
    var o = e && e.require && e.require("util").types;
    return o || r && r.binding && r.binding("util");
  } catch {
  }
})();
export {
  l as default
};
